fragment AiFeatureUsageFragment on AiFeatureUsage {
    currentMonthUsage
    currentMonthLimit
    lastMonthUsage
    features {
        type
        isEnabled
        usage
        requiresUpgrade
        canDisableGlobally
    }
}
